<template>
  <div>
    <div class="iv-skeleton-item">
      <Row :key="$index" v-for="(item, $index) in list">
        <Col :key="$index" v-for="(i, $index) in item" :span="i">
          <div :style="{height: itemHeight}" class="iv-skeleton-color iv-m-r-12 iv-m-b-12"></div>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
// const baseLength = 3
export default {
  props: {
    minHeight: {
      type: Number,
      default: 100
    },
    repeat: {
      type: Number,
      default: 1
    }
  },
  computed: {
    itemHeight () {
      //暂未实现计算高度
      return `15px`
    },
    list () {
      let list = [[8, 16], [16, 8], [6, 8, 10]]
      let res = []
      for (let i = 0; i < this.repeat; i++) res.push(...list)
      return res
    }
  }
}
</script>
<style lang="scss" scoped>
  .iv-skeleton-item {
    .iv-skeleton-color {
      background: #ccc;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/skeleton-screen/index.vue